import { Link } from 'react-router-dom';
import DescriptionIcon from '@mui/icons-material/Description';
import MetaData from '../Layouts/MetaData';

const pages = [
    { label: 'About Us', to: '/admin/pages/about' },
    { label: 'Contact Us', to: '/admin/pages/contact' },
    { label: 'Privacy Policy', to: '/admin/pages/legal/privacy-policy' },
    { label: 'Terms & Conditions', to: '/admin/pages/legal/terms-conditions' },
    { label: 'Refund Policy', to: '/admin/pages/legal/refund-policy' },
    { label: 'Cookie Policy', to: '/admin/pages/legal/cookie-policy' },
];

const PagesTable = () => {
    return (
        <>
            <MetaData title="Admin: Pages | 1313 Mart" />
            <h1 className="text-lg font-medium uppercase mb-4">Pages</h1>
            <div className="bg-white rounded-lg shadow divide-y">
                {pages.map((p) => (
                    <Link key={p.to} to={p.to} className="flex items-center gap-3 p-4 hover:bg-gray-50">
                        <DescriptionIcon className="text-primary-blue" fontSize="small" />
                        <span className="font-medium text-gray-700">{p.label}</span>
                    </Link>
                ))}
            </div>
        </>
    );
};

export default PagesTable;
